import { render, staticRenderFns } from "./VerguetungView.vue?vue&type=template&id=24eff20f&"
import script from "./VerguetungView.vue?vue&type=script&lang=js&"
export * from "./VerguetungView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports